import { useEffect, useCallback, useMemo } from 'react';

import useAsyncDebounce from '../../helpers/debounce';

import useQueryParams from '../helper/useQueryParams';

interface UseSearchAndSetGlobalFilterParams {
    setGlobalFilter: (filterValue: string | undefined) => void;
    queryKey?: string;
    debounceTime?: number;
}

export default function useSearchAndSetGlobalFilter({
    setGlobalFilter,
    queryKey,
    debounceTime = 200,
}: UseSearchAndSetGlobalFilterParams) {
    const query = useQueryParams();

    const searchValue = useMemo(
        () => query[queryKey ?? 'search'],
        [query, queryKey],
    );

    const debouncedSetFilter = useAsyncDebounce(
        useCallback(
            (value: string | undefined) => {
                setGlobalFilter(value);
            },
            [setGlobalFilter],
        ),
        debounceTime,
    );

    useEffect(() => {
        debouncedSetFilter(searchValue);
    }, [searchValue, debouncedSetFilter]);
}
